import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { cancel } from "@ember/runloop";
import { service } from "@ember/service";
import { bind } from "discourse/lib/decorators";
import { isTesting } from "discourse/lib/environment";
import discourseLater from "discourse/lib/later";
import DButton from "discourse/ui-kit/d-button";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import { i18n } from "discourse-i18n";

export default class SoftwareUpdatePrompt extends Component {
  @service messageBus;
  @service session;

  @tracked showPrompt = false;
  @tracked animatePrompt = false;
  timeoutHandler;

  constructor() {
    super(...arguments);

    this.messageBus.subscribe("/refresh_client", this.onRefresh);
    this.messageBus.subscribe("/global/asset-version", this.onAsset);
  }

  willDestroy() {
    super.willDestroy(...arguments);

    this.messageBus.unsubscribe("/refresh_client", this.onRefresh);
    this.messageBus.unsubscribe("/global/asset-version", this.onAsset);

    cancel(this.timeoutHandler);
  }

  @bind
  onRefresh() {
    this.session.requiresRefresh = true;
  }

  @bind
  onAsset(version) {
    if (this.session.assetVersion !== version) {
      this.session.requiresRefresh = true;
    }

    if (!this.timeoutHandler && this.session.requiresRefresh) {
      if (isTesting()) {
        this.addMessage();
      } else {
        // Since we can do this transparently for people browsing the forum
        // hold back the message 24 hours.
        this.timeoutHandler = discourseLater(
          () => this.addMessage(),
          1000 * 60 * 24 * 60
        );
      }
    }
  }

  addMessage() {
    this.showPrompt = true;
    discourseLater(() => (this.animatePrompt = true), 500);
  }

  @action
  refreshPage() {
    document.location.reload();
  }

  @action
  dismiss() {
    this.animatePrompt = false;
    discourseLater(() => (this.showPrompt = false), 500);
  }

  <template>
    {{#if this.showPrompt}}
      <div
        class={{dConcatClass
          "software-update-prompt"
          (if this.animatePrompt "require-software-refresh")
        }}
      >
        <div class="wrap">
          <div aria-live="polite" class="update-prompt-main-content">
            <DButton
              class="btn-transparent update-prompt-message"
              @action={{this.refreshPage}}
              @icon="arrow-rotate-right"
              @label="software_update_prompt.message"
            />

            <span class="update-prompt-dismiss">
              <DButton
                aria-label={{i18n "software_update_prompt.dismiss"}}
                class="btn-transparent"
                @action={{this.dismiss}}
                @icon="xmark"
              />
            </span>
          </div>
        </div>
      </div>
    {{/if}}
  </template>
}
